import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import * as _ from 'lodash';

@Injectable({
    providedIn: 'root'
})
export class DashboardService {
    url: string = environment.apiUrl;
    token: string;
    httpOptions;

    constructor(private http: HttpClient) {}

    fetchToken(done) {
        this.token = localStorage.getItem('riderAuthToken');
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + this.token,
                Accept: 'application/json'
            })
        };

        return done();
    }

    updateLocation(location): Observable<any> {
        return this.fetchToken(() => {
            return this.http
                .post(
                    this.url + '/api/settings/location-update',
                    {
                        lat: location.lat,
                        lng: location.lng
                    },
                    this.httpOptions
                )
                .pipe(
                    tap(data => console.log('data ' + JSON.stringify(data))),
                    catchError(this.handleError)
                );
        });
    }

    requestRide(
        rider_id,
        driver_id,
        location,
        pickupAddress,
        dropPosition,
        drop_location
    ): Observable<any> {
        console.log('pickup address ', pickupAddress);
        return this.fetchToken(() => {
            return this.http
                .post(
                    this.url + '/api/ride/create-ride',
                    {
                        rider_id: +rider_id,
                        driver_id: +driver_id,
                        pickup_address: pickupAddress,
                        pickup_lat: location.lat,
                        pickup_lng: location.lng,
                        dropoff_lat: !_.isEmpty(dropPosition)
                            ? dropPosition.lat
                            : '',
                        dropoff_lng: !_.isEmpty(dropPosition)
                            ? dropPosition.lng
                            : '',
                        destination_address: !_.isEmpty(dropPosition)
                            ? drop_location
                            : ''
                    },
                    this.httpOptions
                )
                .pipe(
                    tap(data => console.log('data ' + JSON.stringify(data))),
                    catchError(this.handleError)
                );
        });
    }

    updateToken(device_token): Observable<any> {
        return this.fetchToken(() => {
            return this.http
                .post(
                    this.url + '/api/settings/device-token-update',
                    {
                        device_type: 'web',
                        device_token
                    },
                    this.httpOptions
                )
                .pipe(
                    tap(data => console.log('data ' + JSON.stringify(data))),
                    catchError(this.handleError)
                );
        });
    }

    getNearbyDrivers(location, dropLocation): Observable<any> {
        return this.fetchToken(() => {
            return this.http
                .post(
                    this.url + '/api/ride/get-available-drivers',
                    {
                        lat: !_.isEmpty(location) ? location.lat : null,
                        lng: !_.isEmpty(location) ? location.lng : null,
                        drop_lat: dropLocation ? dropLocation.lat : null,
                        drop_lng: dropLocation ? dropLocation.lng : null
                    },
                    this.httpOptions
                )
                .pipe(
                    // tap(data => console.log('data ' + JSON.stringify(data))),
                    catchError(this.handleError)
                );
        });
    }

    getUserDetails(): Observable<any> {
        return this.fetchToken(() => {
            return this.http
                .post(this.url + '/api/rider/information', {}, this.httpOptions)
                .pipe(
                    tap(data => console.log),
                    catchError(this.handleError)
                );
        });
    }

    getAddresses(searchString, googleKey): Observable<any> {
        return this.fetchToken(() => {
            return this.http
                .post(
                    this.url + '/api/rider/location-search-details',
                    {
                        search: searchString,
                        key: googleKey
                    },
                    this.httpOptions
                )
                .pipe(
                    tap(data => console.log),
                    catchError(this.handleError)
                );
        });
    }

    addAnotherCard(cdata): Observable<any> {
        return this.fetchToken(() => {
            return this.http
                .post(
                    this.url + '/api/stripe/save-another-card',
                    cdata,
                    this.httpOptions
                )
                .pipe(
                    tap(data => console.log),
                    catchError(this.handleError)
                );
        });
    }

    rateRide(rideId: number, rating: number): Observable<any> {
        return this.fetchToken(() => {
            return this.http
                .post(
                    this.url + '/api/ride/ride-rating-by-rider',
                    { ride_id: rideId, driver_rating: rating },
                    this.httpOptions
                )
                .pipe(
                    tap(data => console.log),
                    catchError(this.handleError)
                );
        });
    }

    payOnline(
        rideId: number,
        amount: number,
        customer_id,
        card_id,
        driver_id
    ): Observable<any> {
        return this.fetchToken(() => {
            return this.http
                .post(
                    this.url + '/api/ride/online-payment-for-meter-taxi',
                    {
                        ride_id: rideId,
                        amount,
                        customer_id,
                        card_id,
                        driver_id
                    },
                    this.httpOptions
                )
                .pipe(
                    tap(data => console.log),
                    catchError(this.handleError)
                );
        });
    }

    sendMessage(message, to, from, ride_id): Observable<any> {
        return this.fetchToken(() => {
            return this.http
                .post(
                    this.url + '/api/message/send-message',
                    {
                        to_userid: to,
                        from_userid: from,
                        ride_id,
                        message
                    },
                    this.httpOptions
                )
                .pipe(
                    tap(data => console.log('data ' + JSON.stringify(data))),
                    catchError(this.handleError)
                );
        });
    }

    logout(): Observable<any> {
        return this.fetchToken(() => {
            return this.http
                .post(this.url + '/api/rider/logout', {}, this.httpOptions)
                .pipe(
                    tap(data => console.log('data ' + JSON.stringify(data))),
                    catchError(this.handleError)
                );
        });
    }

    removeCard(cdata): Observable<any> {
        return this.fetchToken(() => {
            return this.http
                .post(
                    this.url + '/api/stripe/delete-card',
                    cdata,
                    this.httpOptions
                )
                .pipe(
                    tap(data => console.log),
                    catchError(this.handleError)
                );
        });
    }

    changePassword(payload): Observable<any> {
        return this.fetchToken(() => {
            return this.http
                .post(
                    this.url + '/api/rider/change-password',
                    payload,
                    this.httpOptions
                )
                .pipe(
                    tap(data => console.log),
                    catchError(this.handleError)
                );
        });
    }

    getCardList(): Observable<any> {
        return this.fetchToken(() => {
            return this.http
                .post(this.url + '/api/stripe/cards-list', {}, this.httpOptions)
                .pipe(
                    tap(data => console.log),
                    catchError(this.handleError)
                );
        });
    }

    getRiderAcceptBookingList(): Observable<any> {
        
        return this.fetchToken(() => {
            return this.http
                .post(
                    this.url + '/api/ride/rider-get-accept-booking-list',
                    {},
                    this.httpOptions
                )
                .pipe(
                    tap(data => console.log),
                    catchError(this.handleError)
                );
        });

    }

    private handleError(err: HttpErrorResponse) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        let errorMessage = '';
        if (err.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            errorMessage = `An error occurred: ${err.error.message}`;
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
        }
        console.error(errorMessage);
        return throwError(errorMessage);
    }
}
